import React from 'react';
// @ts-ignore
import styles from './ManagerSettingsTableItem.module.scss';

interface Props {
	children: React.ReactNode;
}

const ManagerSettingsTable: React.FC<Props> = ({ children }) => {
	return (
		<table>
			<tbody>{children}</tbody>
		</table>
	);
};

export default ManagerSettingsTable;
